import React, {Component} from "react";
import OwlCarousel from "react-owl-carousel3";
import PropTypes from "prop-types";
import VisibilitySensor from "react-visibility-sensor";

class Banner extends Component {
  render() {
    //BannerOne loop start
    const banneronedata = this.props.banneronesData.map(
      (bannerone, index) => (
        <div className={bannerone.BgClass} key={index}>
          <div className="diplay-table">
            <div className="display-table-cell">
              <VisibilitySensor>
                {({isVisible}) => (
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-7">
                        <h1 className={
                          isVisible
                            ? "animated fadeInDown slow opacityOne"
                            : "opacityZero"
                        }>
                          {bannerone.Title}
                        </h1>
                      </div>
                    </div>
                  </div>
                )}
              </VisibilitySensor>
            </div>
          </div>
        </div>
      )
    );
    //BannerOne loop END
    return (
      <React.Fragment>
        <div id="home" className="hompage-slides-wrapper">
          <OwlCarousel
            className="owl-theme homepage-slides"
            items={1}
            touchDrag={false}
            margin={0}
            mouseDrag={false}
            smartSpeed={1000}
            dotData={true}
            dotsContainer={".owl-thumbs"}
          >
            {banneronedata}
          </OwlCarousel>
        </div>
      </React.Fragment>
    );
  }
}

//Props Types
Banner.propTypes = {
  banneronesData: PropTypes.array,
  thumbsData: PropTypes.array
};

//Default Props
Banner.defaultProps = {
  banneronesData: [
    {
      BgClass: "single-slider-item slide-bg-1",
      Title: "Asociatia CASA MARIA",
    }
  ]
};

export default Banner;
